import BasicButton from 'components/BasicButton';
import PropTypes from 'prop-types';
import React from 'react';

import './styles.css';

function FilesFieldListHeader(props) {
  const { inputRef, title, disabled } = props;

  return (
    <div className="files-field-list__header">
      {title && <h5 className="form__subtitle">{title}</h5>}
      <div className="files-field-list__button">
        <BasicButton
          disabled={disabled}
          controlFunc={() => inputRef.current.click()}
          btnWidth={130}
          btnHeight={35}
          btnFontWeight={500}
          btnArrow={false}
          btnTextColor="#27282d"
          btnText="Add file"
        />
      </div>
    </div>
  );
}

FilesFieldListHeader.propTypes = {
  ref: PropTypes.any,
  title: PropTypes.string,
  disabled: PropTypes.bool,
};

export default FilesFieldListHeader;
